import IconButton from '@/components/common/IconButton';
import { useMetadata } from '@/hooks/useMetadata';
import { VariableScope } from '@/types/variable';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { FC, useState } from 'react';

type VariableListItemEditProps = {
  onClose: () => void;
  variableName?: string;
  variableType?: string;
  scope: VariableScope;
  onSave: (variableName: string, variableType: string) => void;
};

const VariableListItemEdit: FC<VariableListItemEditProps> = (props) => {
  const { metadata } = useMetadata();
  const [variableName, setVariableName] = useState(props.variableName || '');
  const [variableType, setVariableType] = useState(props.variableType || '');

  const handleClose = () => {
    setVariableName('');
    props.onClose();
  };

  const isError = variableName.startsWith('_debug');
  const valid: boolean = !!variableName && !!variableType && !isError;

  return (
    <Stack direction='row' gap={1} pt={1} width='100%' alignItems='center'>
      <TextField
        label='Name'
        value={variableName}
        onChange={(event) => setVariableName(event.currentTarget.value.replaceAll(' ', ''))}
        fullWidth
        size='small'
        autoFocus
        error={isError}
        helperText={isError ? "Lists can not start with '_debug'" : ''}
        InputProps={{ autoComplete: 'off' }}
      />
      <FormControl fullWidth size='small'>
        <InputLabel id='variable-type-select-label'>Type</InputLabel>
        <Select
          labelId='variable-type-select-label'
          id='variable-type-select'
          value={variableType}
          label='Variable type'
          onChange={(event) => setVariableType(event.target.value)}
        >
          {metadata.datatypes.map((valueType, index) => {
            if (valueType.scope?.find((scope) => scope === props.scope)) {
              return (
                <MenuItem key={`valuetype.${valueType.type}.${index}`} value={valueType.type}>
                  {valueType.label}
                </MenuItem>
              );
            }
          })}
        </Select>
      </FormControl>
      <IconButton
        tooltip={valid ? 'Save' : undefined}
        disabled={!valid}
        onClick={() => {
          props.onSave(variableName, variableType);
          handleClose();
        }}
      >
        <SaveIcon />
      </IconButton>
      <IconButton tooltip='Cancel' onClick={() => handleClose()}>
        <CancelIcon />
      </IconButton>
    </Stack>
  );
};

export default VariableListItemEdit;
